
import { reactive, toRefs, defineComponent, defineAsyncComponent } from 'vue';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { IAuthActions, IAuthState } from '../types';
import { ErrorHandling } from '@/common/helpers/ErrorHandling';
import { mapActions } from 'vuex';
const { useState, useActions } = createNamespacedHelpers<
  IAuthState,
  null,
  IAuthActions
>('auth');

export default defineComponent({
  name: 'LoginForm',

  components: {
    BaseButton: defineAsyncComponent(
      () => import('@/components/BaseButton.vue')
    ),
    BaseIcon: defineAsyncComponent(() => import('@/components/BaseIcon.vue')),
    LoginHeader: defineAsyncComponent(() => import('./LoginHeader.vue')),
  },

  methods: {
    ...mapActions('auth', ['setError']),
    loginAction(login: string, password: string) {
      if (login && password) {
        this.authentication({ login, password });
      } else {
        this.setError({
          title: 'Erro',
          message: ErrorHandling('NOT_INFORMED_LOGIN_PASSWORD'),
          visible: true,
        });
      }
    },
  },

  setup() {
    const { loading } = useState(['loading']);
    const { authentication } = useActions(['authentication']);

    const resetPassword = () => {
      console.log(
        'process.env.VUE_APP_RESET_PASSWORD_URL: ',
        process.env.VUE_APP_RESET_PASSWORD_URL
      );
      window.open(process.env.VUE_APP_RESET_PASSWORD_URL);
    };

    const state = reactive({ login: '', password: '' });

    return {
      ...toRefs(state),
      loading,
      authentication,
      resetPassword,
    };
  },
});
